export const IIconViewModelType = Symbol('IIconViewModel');
